import { ref } from "vue";

interface UseTapRecognizerOptions<T> {
    onTap: (arg: T, e: TouchEvent) => void;
    tolerance?: number;
    toleranceX?: number;
    toleranceY?: number;
    isDisabled?: () => boolean;
    shouldPreventDefault?: boolean; // default: true
}

export function useTapRecognizer<T = void>(options: UseTapRecognizerOptions<T>) {
    const touchStartX = ref(0);
    const touchStartY = ref(0);
    const toleranceX = options.toleranceX ?? options.tolerance ?? 10;
    const toleranceY = options.toleranceY ?? options.tolerance ?? 10;

    function onTouchStart(e: TouchEvent) {
        console.log("onTouchStart", e);
        const touch = e.touches[0];
        touchStartX.value = touch.clientX;
        touchStartY.value = touch.clientY;
    }

    function onTouchEnd(e: TouchEvent, param: T) {
        console.log("onTouchEnd", e);
        const touch = e.changedTouches[0];
        const deltaX = Math.abs(touch.clientX - touchStartX.value);
        const deltaY = Math.abs(touch.clientY - touchStartY.value);

        if (deltaX <= toleranceX && deltaY <= toleranceY) {
            console.log("tapped", deltaX, deltaY);
            if (options.shouldPreventDefault === true || options.shouldPreventDefault === undefined) {
                e.preventDefault();
            }
            if (!options.isDisabled?.()) {
                options.onTap(param, e);
            }
        } else {
            console.log("skipped", deltaX, deltaY);
        }
    }

    return {
        onTouchStart,
        onTouchEnd,
    };
}
